<ridango-page-content-wrapper id="main-content">
    <ridango-ui-rotating-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-rotating-loading-spinner>
</ridango-page-content-wrapper>
